/**
 * Lista de componentes documentados
 */
export default [
    {
        name: 'Authenticator',
        type: 'Componente',
        description: 'Formulário de login e/ou recuperação de senha.',
        icon: 'mdi-key-variant',
        path: '/docs/components/authenticator',
        status: 100,
        current: false,
    },
    {
        name: 'App',
        type: 'Componente',
        description: 'Container principal utilizado no layout desejado, substitui o v-app do vuetity.',
        icon: 'mdi-page-layout-body',
        path: '/docs/components/app',
        status: 100,
        current: false,
    },
    {
        name: 'NavBar',
        type: 'Componente',
        description: 'Barra de navegação (header) do sistema.',
        icon: 'mdi-page-layout-header',
        path: '/docs/components/navbar',
        status: 100,
        current: true,
    },
    {
        name: 'Sidebar',
        type: 'Componente',
        description: 'Barra de menu flutuante (esquerdo) do sistema.',
        icon: 'mdi-page-layout-sidebar-left',
        path: '/docs/components/sidebar',
        status: 100,
    },
    {
        name: 'QuickBar',
        type: 'Componente',
        description: 'Barra de acesso rápido as funcionalidades do sistema.',
        icon: 'mdi-page-layout-sidebar-right',
        path: '/docs/components/quickbar',
        status: 100,
    },
    {
        name: 'FooterBar',
        type: 'Componente',
        description: 'Barra de informações gerais (footer) do sistema.',
        icon: 'mdi-page-layout-footer',
        path: '/docs/components/footerbar',
        status: 100,
    },
    {
        name: 'ModulesPanel',
        type: 'Componente',
        description: 'Lista os modulos principais do sistema.',
        icon: 'mdi-apps',
        path: '/docs/components/modules-panel',
        status: 100,
    },
    {
        name: 'HistoryPanel',
        type: 'Componente',
        description: 'Lista as últimas navegações do usuário no sistema.',
        icon: 'mdi-arrow-u-left-top-bold',
        path: '/docs/components/history-panel',
        status: 100,
    },
    {
        name: 'NavigationPanel',
        type: 'Componente',
        description: 'Une os paineis de navegação (modulos e histórico).',
        icon: 'mdi-menu',
        path: '/docs/components/navigation-panel',
        status: 100,
    },
    {
        name: 'Messenger',
        type: 'Componente',
        description: 'Útil para conversação entre os usuários do sistema (chat).',
        icon: 'mdi-chat-processing',
        path: '/docs/components/messenger',
        status: 100,
    },
    {
        name: 'ShortBtn',
        type: 'Componente',
        description: 'Botão de atalho (vertical) útil para diversas partes do sistema.',
        icon: 'mdi-card',
        path: '/docs/components/short-btn',
        status: 100,
    },
    {
        name: 'Translator',
        type: 'Componente',
        description: 'Botão para troca do idioma.',
        icon: 'mdi-translate',
        path: '/docs/components/translator',
        status: 100,
    },
    {
        name: 'TreeMenu',
        type: 'Componente',
        description: 'Árvore de menu com até 3 níveis de profundidade.',
        icon: 'mdi-file-tree',
        path: '/docs/components/tree-menu',
        status: 100,
    },
    {
        name: 'ShowMessage',
        type: 'Componente',
        description: 'Exibe alerta em qualquer área da aplicação.',
        icon: 'mdi-dock-window',
        path: '/docs/components/show-message',
        status: 100,
    },
    {
        name: 'CodeView',
        type: 'Componente',
        description: 'Painel para exibir código fonte da documentação.',
        icon: 'mdi-code-braces',
        path: '/docs/components/code-block/code-view',
        status: 100,
    },
    {
        name: 'CodeBlock',
        type: 'Componente',
        description: 'Card para exibir informações da documentação.',
        icon: 'mdi-code-tags',
        path: '/docs/components/code-block/code-block',
        status: 100,
    },
    {
        name: 'PageView',
        type: 'Componente',
        description: 'Área de visualização das páginas do sistema.',
        icon: 'mdi-page-layout-body',
        path: '/docs/components/page-view',
        status: 100,
    },
    {
        name: 'CrudView',
        type: 'Componente',
        description: 'Container para contrução de CRUD.',
        icon: 'mdi-format-line-style',
        path: '/docs/components/crud-view',
        status: 100,
    },
    {
        name: 'DataGrid',
        type: 'Componente',
        description: 'Grade para listar dados do sistema.',
        icon: 'mdi-table-large',
        path: '/docs/components/data-table',
        status: 100,
    },
    {
        name: 'Card',
        type: 'Componente',
        description: 'Componente card minimalista utilizado como base para outros componentes.',
        icon: 'mdi-card-bulleted-outline',
        path: '/docs/components/card',
        status: 100,
    },
    {
        name: 'InputField',
        type: 'Componente',
        description: 'Campo para entrada de dados.',
        icon: 'mdi-form-textbox',
        path: '/docs/components/input-field',
        status: 30,
    },
    {
        name: 'FormBuilder',
        type: 'Componente',
        description: 'Construtor de formulário para entrada ou exibição de dados.',
        icon: 'mdi-window-shutter-cog',
        path: '/docs/components/form-builder',
        status: 25,
    },
    {
        name: 'ChartCard',
        type: 'Componente',
        description: 'Painel específico (widget) para exibir gráficos do sistema.',
        icon: 'mdi-finance',
        path: '/docs/components/chart-card',
        status: 100,
    },
    {
        name: 'ReportView',
        type: 'Componente',
        description: 'Integração com gerador de relatórios do servidor (Stimulsoft).',
        icon: 'mdi-file-pdf-box',
        path: '',
        status: 0,
    },
];
